import React from 'react'
import './BlogDetailsPage.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarDays, faClock } from '@fortawesome/free-solid-svg-icons'
import Back_Btn from '../../Common_Component/Common_Btn/Back_Btn/Back_Btn'
import { useNavigate } from 'react-router-dom'

const BlogDetailsPage = () => {

    const navigate = useNavigate()

    return (
        <section className='BlogDetailsPage'>

            <div className='container'>
                <div className='back_btn_holder'>
                    <Back_Btn btn_name="Back" onClick={() => {
                        navigate("/blogs")
                    }} />
                </div>
            </div>

            <div className='blog_detail_banner'>

                <div className='container-fluid p-0'>
                    <div className='banner_img_holder'>
                        <img src={"/assets/Image/Blogs/blog_details/Group 52649.png"} className='banner_img' alt="Banner" />
                    </div>
                </div>

                <div className='container'>
                    <div className='banner_text_holder'>

                        <div className=''>
                            <p className='banner_heading'>Term Insurance</p>
                            <p className='subtext1'>Explore our thoughtfully curated articles, tailored to help you make well-informed decisions about term insurance.</p>
                        </div>

                        <div className='banner_footer'>
                            <div className='date_text_div'>
                                <p className='date_text'>
                                    <FontAwesomeIcon icon={faCalendarDays} className='date_icon' />
                                    MAR 13, 2025
                                </p>
                            </div>

                            <div className='date_text_div'>
                                <p className='date_text'>
                                    <FontAwesomeIcon icon={faClock} className='date_icon' />
                                    2 hrs ago
                                </p>
                            </div>
                        </div>

                    </div>
                </div>

                <div className='blog_inner_img_holder'>
                    <img src='\assets\Image\Blogs\blog_details\inner_blog.png' className='img' />
                </div>

            </div>

            <div className='container'>
                <div className='blog_text_holder'>
                    <p className='blog_text'>
                        Hiring our nation’s heroes can yield positive returns for employers that invest in veteran hiring. With their unmatched technical and leadership skills, strong work ethic, and unwavering commitment to safety and integrity in the workplace, veterans can generate positive outcome that can impact a business’s bottom line. In fact, one analysis showed that a company of 1,000 employees, 25% of whom are veterans, an experience an annual cost savings of $325,000.
                    </p>

                    <p className='blog_text'>
                        Hiring our nation’s heroes can yield positive returns for employers that invest in veteran hiring. With their unmatched technical and leadership skills, strong work ethic, and unwavering commitment to safety and integrity in the workplace, veterans can generate positive outcome that can impact a business’s bottom line. In fact, one analysis showed that a company of 1,000 employees, 25% of whom are veterans, an experience an annual cost savings of $325,000.
                    </p>

                    <p className='blog_text'>
                        Hiring our nation’s heroes can yield positive returns for employers that invest in veteran hiring. With their unmatched technical and leadership skills, strong work ethic, and unwavering commitment to safety and integrity in the workplace, veterans can generate positive outcome that can impact a business’s bottom line. In fact, one analysis showed that a company of 1,000 employees, 25% of whom are veterans, an experience an annual cost savings of $325,000.
                    </p>

                    <p className='blog_text'>
                        Hiring our nation’s heroes can yield positive returns for employers that invest in veteran hiring. With their unmatched technical and leadership skills, strong work ethic, and unwavering commitment to safety and integrity in the workplace, veterans can generate positive outcome that can impact a business’s bottom line. In fact, one analysis showed that a company of 1,000 employees, 25% of whom are veterans, an experience an annual cost savings of $325,000.
                    </p>
                </div>
            </div>

        </section>
    )
}

export default BlogDetailsPage
